// ==============================|| NOT FOUND / DISCONNECTED ||============================== //

const NotFound = () => {
    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--bg)',
                fontFamily: "'Pretendard', 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif"
            }}
        >
            <div
                style={{
                    padding: 32,
                    textAlign: 'center',
                    background: 'var(--surface)',
                    border: '1px solid var(--border)',
                    borderRadius: 14,
                    boxShadow: 'var(--shadow-sm)'
                }}
            >
                <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>Page Not Found</h2>
                <p style={{ marginTop: 8, color: 'var(--text-muted)' }}>404</p>
            </div>
        </div>
    );
};

export default NotFound;
